<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<section class="white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">{{ 'FOOTER.CAREERS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'FOOTER.CAREERS_TEXT' | translate }}</p>
                </div>
                <div class="careers-content">
                    <div class="careers-section">
                        <h4>{{ 'FOOTER.CAREERS_WHY_JOIN_TITLE' | translate }}</h4>
                        <ul>
                            <li>{{ 'FOOTER.CAREERS_WHY_JOIN_1' | translate }}</li>
                            <li>{{ 'FOOTER.CAREERS_WHY_JOIN_2' | translate }}</li>
                            <li>{{ 'FOOTER.CAREERS_WHY_JOIN_3' | translate }}</li>
                            <li>{{ 'FOOTER.CAREERS_WHY_JOIN_4' | translate }}</li>
                        </ul>
                    </div>
                    <div class="careers-section">
                        <h4>{{ 'FOOTER.CAREERS_OPEN_POSITIONS_TITLE' | translate }}</h4>
                        <div class="position-cards">
                            <div class="position-card">
                                <h5>{{ 'FOOTER.CAREERS_POSITION_1_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.CAREERS_POSITION_1_DESC' | translate }}</p>
                                <a href="mailto:jobs@propero.io" class="btn btn-primary">{{ 'FOOTER.CAREERS_APPLY_NOW' | translate }}</a>
                            </div>
                            <div class="position-card">
                                <h5>{{ 'FOOTER.CAREERS_POSITION_2_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.CAREERS_POSITION_2_DESC' | translate }}</p>
                                <a href="mailto:jobs@propero.io" class="btn btn-primary">{{ 'FOOTER.CAREERS_APPLY_NOW' | translate }}</a>
                            </div>
                            <div class="position-card">
                                <h5>{{ 'FOOTER.CAREERS_POSITION_3_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.CAREERS_POSITION_3_DESC' | translate }}</p>
                                <a href="mailto:jobs@propero.io" class="btn btn-primary">{{ 'FOOTER.CAREERS_APPLY_NOW' | translate }}</a>
                            </div>
                            <div class="position-card">
                                <h5>{{ 'FOOTER.CAREERS_POSITION_4_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.CAREERS_POSITION_4_DESC' | translate }}</p>
                                <a href="mailto:jobs@propero.io" class="btn btn-primary">{{ 'FOOTER.CAREERS_APPLY_NOW' | translate }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="careers-section">
                        <h4>{{ 'FOOTER.CAREERS_BENEFITS_TITLE' | translate }}</h4>
                        <div class="benefits-grid">
                            <div class="benefit-item">
                                <i class="lni lni-hourglass"></i>
                                <h5>{{ 'FOOTER.CAREERS_BENEFIT_1_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.CAREERS_BENEFIT_1_DESC' | translate }}</p>
                            </div>
                            <div class="benefit-item">
                                <i class="lni lni-timer"></i>
                                <h5>{{ 'FOOTER.CAREERS_BENEFIT_2_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.CAREERS_BENEFIT_2_DESC' | translate }}</p>
                            </div>
                            <div class="benefit-item">
                                <i class="lni lni-graduation"></i>
                                <h5>{{ 'FOOTER.CAREERS_BENEFIT_3_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.CAREERS_BENEFIT_3_DESC' | translate }}</p>
                            </div>
                            <div class="benefit-item">
                                <i class="lni lni-home"></i>
                                <h5>{{ 'FOOTER.CAREERS_BENEFIT_4_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.CAREERS_BENEFIT_4_DESC' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> 